import dev from './settings/dev';
import prod from './settings/prod';

class Settings {
  constructor() {
    let json;
    if (location.hostname.indexOf('local') >= 0) {
      json = dev;
    } else {
      json = prod;
    }

    for (var key in json) {
      if (json.hasOwnProperty(key)) {
        this[key] = json[key];
      }
    }
  }
}

export default new Settings();



// WEBPACK FOOTER //
// ./src/resources/settings.js